/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PaymentStatus {
	New = 'New',
	Unpaid = 'Unpaid',
	Pending = 'Pending',
	Paid = 'Paid',
	Declined = 'Declined',
	Refunded = 'Refunded',
	Cancelled = 'Cancelled',
	Disputed = 'Disputed',
	Reversed = 'Reversed',
	PartiallyReversed = 'PartiallyReversed',
	PartiallyRefunded = 'PartiallyRefunded',
	PartiallyPaid = 'PartiallyPaid',
	Quote = 'Quote',
}
